import { addItemToCollection } from "directus/src/operations";

export async function createJobTitle({ item }) {
  try {
    const data = await addItemToCollection("job_titles", item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
